import system from "system-components"

const Container = system({
  width: 0.85,
  maxWidth: 928,
  mx: "auto",
})

Container.displayName = "Container"

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js